import { ref } from '@vue/composition-api'

export const useControlCenter = () => {
  // 控制打标弹窗
  const showLabel = ref(false)
  const showScore = ref(false)

  // 控制日志弹窗
  const showLog = ref(false)

  // 选择操作的用户
  const selectedUserArr = ref([])

  // 设置选中的用户
  const setSelectedUserArr = (row) => {
    if (Array.isArray(row)) {
      selectedUserArr.value = [...row]
    } else {
      selectedUserArr.value = [row]
    }
  }

  // 获取选中用户userIds
  const getSelectedUserIds = () => {
    return selectedUserArr.value
      .map((item) => {
        return item.userId
      })
      .join(',')
  }

  // 打开积分发放弹窗
  const handleScore = (row, callback) => {
    setSelectedUserArr(row)
    callback && callback()
    showScore.value = true
  }
  // 关闭积分发放弹窗
  const closeScoreDialog = () => {
    showScore.value = false
  }

  // 打开打标弹窗
  const handleLabel = (row) => {
    setSelectedUserArr(row)
    showLabel.value = true
  }
  // 关闭打标弹窗
  const closeLabelDialog = () => {
    showLabel.value = false
  }

  // 查看积分明细
  const showScoreStatistics = ref(false)
  const viewScoreStatistics = (row) => {
    setSelectedUserArr(row)
    showScoreStatistics.value = true
  }

  // 查看成长值明细
  const showGrowthStatistics = ref(false)
  const viewGrowthStatistics = (row) => {
    setSelectedUserArr(row)
    showGrowthStatistics.value = true
  }

  // 解析备注字段 '下单金额积分奖励${orderId=432304558309212&orderNo=2023121309523728632728715&orderType=2}'
  const analysisRemarkToOrderInfo = (remark) => {
    if (!remark) {
      return {}
    }
    const obj = {}
    obj.remarkStr = remark.replace(/\$\{[\w=&]+\}/, '')
    remark.replace(/([^{&+]+)=([^}&+]+)/g, ($0, $1, $2) => {
      obj[$1] = $2
    })
    return obj
  }

  // 查看操作日志
  const viewLog = () => {
    showLog.value = true
  }
  // 关闭日志弹窗
  const handleCloseLog = () => {
    showLog.value = false
  }

  return {
    showLabel,
    showScore,
    showLog,
    selectedUserArr,
    setSelectedUserArr,
    getSelectedUserIds,
    handleScore,
    closeScoreDialog,
    handleLabel,
    closeLabelDialog,
    showScoreStatistics,
    viewScoreStatistics,
    viewLog,
    handleCloseLog,
    showGrowthStatistics,
    viewGrowthStatistics,
    analysisRemarkToOrderInfo
  }
}
